var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgG4Light(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 43,
    viewBox: "0 0 44 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1135_1976)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.26,
    height: 42.26,
    transform: "translate(0.972656)",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.79777 32.4474C8.77045 32.4474 7.85698 33.0886 7.45747 33.7158C7.22897 32.9606 6.60114 32.4474 5.57384 32.4474C4.53212 32.4474 3.61877 33.1314 3.33346 33.5591V32.6185L1.83496 32.6184V39.5016H3.33352V34.6991C3.64734 34.243 4.26091 33.7726 4.91743 33.7726C5.73069 33.7726 6.05906 34.2713 6.05906 35.0126V39.5014H7.55742V34.6847C7.85698 34.243 8.48477 33.7726 9.1557 33.7726C9.95471 33.7726 10.283 34.2713 10.283 35.0126V39.5014H11.7813V34.5279C11.7811 33.1314 11.0677 32.4474 9.79777 32.4474Z",
    fill: "#EE2432"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8329 38.3472C15.5628 38.3472 14.8492 37.2781 14.8492 36.0527C14.8492 34.8415 15.5625 33.7727 16.8329 33.7727C18.117 33.7727 18.8305 34.8415 18.8305 36.0527C18.8305 37.2781 18.117 38.3472 16.8329 38.3472ZM16.8329 32.4472C14.6495 32.4472 13.2939 34.0861 13.2939 36.0527C13.2939 38.0339 14.6495 39.6726 16.8329 39.6726C19.0444 39.6726 20.3864 38.0337 20.3864 36.0527C20.3861 34.0861 19.0444 32.4472 16.8329 32.4472Z",
    fill: "#EE2432"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.453 35.3117C23.6394 35.1266 22.9545 34.9841 22.9545 34.4853C22.9545 34.0005 23.4541 33.6445 24.2388 33.6445C25.0951 33.6445 25.8659 34.0005 26.2792 34.4709L26.9072 33.4162C26.2792 32.8605 25.3945 32.4474 24.2243 32.4474C22.4833 32.4474 21.513 33.4162 21.513 34.5421C21.513 36.0813 22.926 36.3948 24.11 36.6512C24.9519 36.8367 25.6797 36.9935 25.6797 37.5633C25.6797 38.1048 25.2229 38.4895 24.3242 38.4895C23.4248 38.4895 22.4691 38.0195 21.9836 37.5204L21.2988 38.6034C22.0122 39.3016 23.0827 39.6725 24.253 39.6725C26.1081 39.6725 27.1211 38.7463 27.1211 37.5348C27.1215 35.9103 25.6516 35.5682 24.453 35.3117Z",
    fill: "#EE2432"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.4052 37.6632C28.863 37.6632 28.4062 38.1193 28.4062 38.6607C28.4062 39.202 28.8632 39.6582 29.4052 39.6582C29.9474 39.6582 30.4041 39.202 30.4041 38.6607C30.4041 38.1193 29.9474 37.6632 29.4052 37.6632Z",
    fill: "#EE2432"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.6292 33.6302V32.6182H32.1309V39.5015L33.6292 39.5016V34.8131C33.929 34.3284 34.771 33.901 35.3989 33.901C35.5841 33.901 35.7412 33.9151 35.8696 33.9437V32.4618C34.9704 32.4618 34.143 32.9746 33.6292 33.6302Z",
    fill: "#EE2432"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.7344 32.6184V37.4495C41.3776 37.9195 40.721 38.3472 39.9647 38.3472C39.1228 38.3472 38.5805 38.0196 38.5805 36.9506V32.6184H37.082V37.4924C37.082 38.9031 37.81 39.6726 39.2939 39.6726C40.3783 39.6726 41.2348 39.1454 41.734 38.5897V39.5017L43.2327 39.5016V32.6184H41.7344Z",
    fill: "#EE2432"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7104 3.69799H31.357V22.3592C31.357 22.7926 31.0038 23.1455 30.5695 23.1455H28.2965C26.1104 23.1455 24.2233 23.5068 22.1141 25.8132L22.1058 23.1455H14.498C14.0638 23.1455 13.7105 22.7927 13.7105 22.3592L13.7104 3.69799ZM12.1875 22.3592C12.1875 23.6315 13.224 24.6665 14.498 24.6665H20.8333V28.9366L22.2322 27.4635C24.2275 25.3986 25.8146 24.6665 28.2965 24.6665H30.5695C31.8436 24.6665 32.88 23.6315 32.88 22.3592V2.1771H12.1875V22.3592Z",
    fill: "#EE2432"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1135_1976"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.26,
    height: 42.26,
    fill: "white",
    transform: "translate(0.972656)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgG4Light);
export default __webpack_public_path__ + "static/media/g4Light.a1e392fbe6dcf8bbfbcef85b96ecfdcf.svg";
export { ForwardRef as ReactComponent };